import { render, staticRenderFns } from "./Challenge.vue?vue&type=template&id=687a1d73&"
import script from "./Challenge.vue?vue&type=script&lang=js&"
export * from "./Challenge.vue?vue&type=script&lang=js&"
import style0 from "./Challenge.vue?vue&type=style&index=0&id=687a1d73&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports